export enum ExportProjectKeys {
    MasterFormat = 'masterFormat',
    Company = 'company',
    ListingUrl = 'listingUrl',
    TransparencyCatalogUrl = 'transparencyCatalogUrl',
    WebsiteUrl = 'websiteUrl',
    ProductName = 'productName',
    ProductNameCorrected = 'productNameCorrected',
    Description = 'description',
    FinishScheduleID = 'finishScheduleId',
    descriptionCorrected = 'descriptionCorrected',
    Tags = 'tagsCSV',
    ProductUrl = 'productUrl',
    BasisOfDesign = 'basisOfDesign',
    Substitutions = 'substitutions',
    Pricing = 'pricing',
    PricingType = 'pricingType',
    EpdProgram = 'epdProgram',
    EpdId = 'epdID',
    EpdType = 'epdType',
    ScopeRegion = 'scopeRegion',
    Ec3EmbodiedCarbon = 'ec3EmbodiedCarbon',
    EC3CategoryStatus = 'ec3CategoryStatus',
    EpdExpiresDate = 'epdExpiresDate',
    HPD = 'hpd',
    HpdScopeResults = 'hpdScopeResults',
    HpdScopeResultsCorrected = 'hpdScopeResultsCorrected',
    HpdExpiresDate = 'hpdExpiresDate',
    hpdVerified = 'hpdVerified',
    c2cRestrictedListFree = 'c2cRestrictedListFree',
    livingBuildingChallengeRedListFree = 'livingBuildingChallengeRedListFree',
    perkinsWillPrecautionaryListFree = 'perkinsWillPrecautionaryListFree',
    Declare = 'declare',
    DeclareResults = 'declareResults',
    DeclareExpiresDate = 'declareExpiresDate',
    DeclareVerified = 'declareVerified',
    C2cCertified = 'c2cCertified',
    C2cResults = 'c2cResults',
    C2cExpiresDate = 'c2cExpiresDate',
    C2cMHC = 'c2cMHC',
    C2cMHCResults = 'c2cMHCResults',
    C2cMHCExpiresDate = 'c2cMHCExpiresDate',
    Level = 'level',
    LPC = 'lpc',
    LpcResults = 'lpcResults',
    LpcExpiresDate = 'lpcExpiresDate',
    MfrInv = 'mfrInv',
    MfrInvResults = 'mfrInvResults',
    // CMF Impact Areas (single comma-separated column per disclosure)
    EpdCmfImpactAreas = 'epdCmfImpactAreas',
    HpdCmfImpactAreas = 'hpdCmfImpactAreas',
    DeclareCmfImpactAreas = 'declareCmfImpactAreas',
    C2cCmfImpactAreas = 'c2cCmfImpactAreas',
    C2cMHCCmfImpactAreas = 'c2cMHCCmfImpactAreas',
    LpcCmfImpactAreas = 'lpcCmfImpactAreas',
    // Low-emitting types
    CleanAirSilverVerified = 'lowEmittingTypes.hasCleanAirSilver',
    CleanAirSilverExpires = 'lowEmittingTypes.cleanAirSilverExpires',
    CleanAirSilverCmfImpactAreas = 'cleanAirSilverCmfImpactAreas',
    CleanAirGoldVerified = 'lowEmittingTypes.hasCleanAirGold',
    CleanAirGoldExpires = 'lowEmittingTypes.cleanAirGoldExpires',
    CleanAirGoldCmfImpactAreas = 'cleanAirGoldCmfImpactAreas',
    ClearchemVerified = 'lowEmittingTypes.hasClearchem',
    ClearchemExpires = 'lowEmittingTypes.clearchemExpires',
    ClearchemCmfImpactAreas = 'clearchemCmfImpactAreas',
    FloorscoreVerified = 'lowEmittingTypes.hasFloorscore',
    FloorscoreExpires = 'lowEmittingTypes.floorscoreExpires',
    FloorscoreCmfImpactAreas = 'floorscoreCmfImpactAreas',
    GreenCertifiedVerified = 'lowEmittingTypes.hasGreenCertified',
    GreenCertifiedExpires = 'lowEmittingTypes.greenCertifiedExpires',
    GreenCertifiedCmfImpactAreas = 'greenCertifiedCmfImpactAreas',
    GreenguardVerified = 'lowEmittingTypes.hasGreenguard',
    GreenguardExpires = 'lowEmittingTypes.greenguardExpires',
    GreenguardCmfImpactAreas = 'greenguardCmfImpactAreas',
    GreenguardGoldVerified = 'lowEmittingTypes.hasGreenguardGold',
    GreenguardGoldExpires = 'lowEmittingTypes.greenguardGoldExpires',
    GreenguardGoldCmfImpactAreas = 'greenguardGoldCmfImpactAreas',
    IndoorAdvantageVerified = 'lowEmittingTypes.hasIndoorAdvantage',
    IndoorAdvantageExpires = 'lowEmittingTypes.indoorAdvantageExpires',
    IndoorAdvantageCmfImpactAreas = 'indoorAdvantageCmfImpactAreas',
    IndoorAdvantageGoldVerified = 'lowEmittingTypes.hasIndoorAdvantageGold',
    IndoorAdvantageGoldExpires = 'lowEmittingTypes.indoorAdvantageGoldExpires',
    IndoorAdvantageGoldCmfImpactAreas = 'indoorAdvantageGoldCmfImpactAreas',
}

export const CSVHeader = [
    { label: 'MasterFormat', key: ExportProjectKeys.MasterFormat },
    { label: 'Company', key: ExportProjectKeys.Company },
    { label: 'Transparency Catalog URL', key: ExportProjectKeys.TransparencyCatalogUrl },
    { label: 'Product', key: ExportProjectKeys.ProductNameCorrected },
    { label: 'Description', key: ExportProjectKeys.descriptionCorrected },
    { label: 'Tags', key: ExportProjectKeys.Tags },
    { label: 'Product URL', key: ExportProjectKeys.ProductUrl },
    { label: 'Basis of design', key: ExportProjectKeys.BasisOfDesign },
    { label: 'Substitutions', key: ExportProjectKeys.Substitutions },
    { label: 'Finish schedule ID', key: ExportProjectKeys.FinishScheduleID },
    { label: 'Pricing', key: ExportProjectKeys.Pricing },
    { label: 'Pricing type', key: ExportProjectKeys.PricingType },
    //EPD starts here
    { label: 'EPD program', key: ExportProjectKeys.EpdProgram },
    { label: 'EPD ID', key: ExportProjectKeys.EpdId },
    { label: 'EPD type', key: ExportProjectKeys.EpdType },
    //Add CMF here 
    { label: 'Scope | Region', key: ExportProjectKeys.ScopeRegion },
    { label: 'EC3 embodied carbon', key: ExportProjectKeys.Ec3EmbodiedCarbon },
    { label: 'EC3 category status', key: ExportProjectKeys.EC3CategoryStatus },// is EC3 another disclosure or its in EPD itself? i guess not as it does not have the same property as other disclosures
    { label: 'EPD expires', key: ExportProjectKeys.EpdExpiresDate },
    { label: 'EPD CMF impact areas', key: ExportProjectKeys.EpdCmfImpactAreas },
    //HPD starts here for EPD
    { label: 'Health Product Declaration (HPD)', key: ExportProjectKeys.HPD },
    { label: 'HPD Scope | Results', key: ExportProjectKeys.HpdScopeResultsCorrected },
    { label: 'HPD expires', key: ExportProjectKeys.HpdExpiresDate },
    { label: 'HPD verified', key: ExportProjectKeys.hpdVerified },
    { label: 'HPD CMF impact areas', key: ExportProjectKeys.HpdCmfImpactAreas },
    { label: 'C2C restricted list free', key: ExportProjectKeys.c2cRestrictedListFree },
    { label: 'Living Building Challenge red list free', key: ExportProjectKeys.livingBuildingChallengeRedListFree },
    { label: 'Perkins&Will precautionary list free', key: ExportProjectKeys.perkinsWillPrecautionaryListFree },
    //Declare starts here
    { label: 'Declare', key: ExportProjectKeys.Declare },
    { label: 'Declare results', key: ExportProjectKeys.DeclareResults },
    { label: 'Declare expires', key: ExportProjectKeys.DeclareExpiresDate },
    { label: 'Declare verified', key: ExportProjectKeys.DeclareVerified },
    { label: 'Declare CMF impact areas', key: ExportProjectKeys.DeclareCmfImpactAreas },
    { label: 'C2C certified', key: ExportProjectKeys.C2cCertified },
    { label: 'C2C results', key: ExportProjectKeys.C2cMHCResults },
    { label: 'C2C expires', key: ExportProjectKeys.C2cExpiresDate },
    { label: 'C2C CMF impact areas', key: ExportProjectKeys.C2cCmfImpactAreas },
    { label: 'C2C Material Health Certificate (MHC)', key: ExportProjectKeys.C2cMHC },
    { label: 'C2C MHC results', key: ExportProjectKeys.C2cMHCResults },
    { label: 'C2C MHC expires', key: ExportProjectKeys.C2cMHCExpiresDate },
    { label: 'C2C MHC CMF impact areas', key: ExportProjectKeys.C2cMHCCmfImpactAreas },
    { label: 'Level', key: ExportProjectKeys.Level },
    { label: 'Living Product Challenge (LPC)', key: ExportProjectKeys.LPC },
    { label: 'LPC results', key: ExportProjectKeys.LpcResults },
    { label: 'LPC expires', key: ExportProjectKeys.LpcExpiresDate },
    { label: 'LPC CMF impact areas', key: ExportProjectKeys.LpcCmfImpactAreas },
    { label: 'Manufacturer Inventory (Mfr Inv)', key: ExportProjectKeys.MfrInv },
    { label: 'Mfr Inv | Scope', key: ExportProjectKeys.MfrInvResults },
    // Low-emitting types CSV headers
    { label: 'Intertek Clean Air SILVER Verified', key: ExportProjectKeys.CleanAirSilverVerified },
    { label: 'Intertek Clean Air SILVER Expires', key: ExportProjectKeys.CleanAirSilverExpires },
    { label: 'Clean Air SILVER CMF impact areas', key: ExportProjectKeys.CleanAirSilverCmfImpactAreas },
    { label: 'Intertek Clean Air GOLD Verified', key: ExportProjectKeys.CleanAirGoldVerified },
    { label: 'Intertek Clean Air GOLD Expires', key: ExportProjectKeys.CleanAirGoldExpires },
    { label: 'Clean Air GOLD CMF impact areas', key: ExportProjectKeys.CleanAirGoldCmfImpactAreas },
    { label: 'Berkeley Analytical ClearChem Verified', key: ExportProjectKeys.ClearchemVerified },
    { label: 'Berkeley Analytical ClearChem Expires', key: ExportProjectKeys.ClearchemExpires },
    { label: 'ClearChem CMF impact areas', key: ExportProjectKeys.ClearchemCmfImpactAreas },
    { label: 'SCS Global FloorScore Verified', key: ExportProjectKeys.FloorscoreVerified },
    { label: 'SCS Global FloorScore Expires', key: ExportProjectKeys.FloorscoreExpires },
    { label: 'FloorScore CMF impact areas', key: ExportProjectKeys.FloorscoreCmfImpactAreas },
    { label: 'MAS Green Certified Verified', key: ExportProjectKeys.GreenCertifiedVerified },
    { label: 'MAS Green Certified Expires', key: ExportProjectKeys.GreenCertifiedExpires },
    { label: 'Green Certified CMF impact areas', key: ExportProjectKeys.GreenCertifiedCmfImpactAreas },
    { label: 'UL Solutions GREENGUARD Verified', key: ExportProjectKeys.GreenguardVerified },
    { label: 'UL Solutions GREENGUARD Expires', key: ExportProjectKeys.GreenguardExpires },
    { label: 'GREENGUARD CMF impact areas', key: ExportProjectKeys.GreenguardCmfImpactAreas },
    { label: 'UL Solutions GREENGUARD Gold Verified', key: ExportProjectKeys.GreenguardGoldVerified },
    { label: 'UL Solutions GREENGUARD Gold Expires', key: ExportProjectKeys.GreenguardGoldExpires },
    { label: 'GREENGUARD Gold CMF impact areas', key: ExportProjectKeys.GreenguardGoldCmfImpactAreas },
    { label: 'SCS Global Indoor Advantage Verified', key: ExportProjectKeys.IndoorAdvantageVerified },
    { label: 'SCS Global Indoor Advantage Expires', key: ExportProjectKeys.IndoorAdvantageExpires },
    { label: 'Indoor Advantage CMF impact areas', key: ExportProjectKeys.IndoorAdvantageCmfImpactAreas },
    { label: 'SCS Global Indoor Advantage Gold Verified', key: ExportProjectKeys.IndoorAdvantageGoldVerified },
    { label: 'SCS Global Indoor Advantage Gold Expires', key: ExportProjectKeys.IndoorAdvantageGoldExpires },
    { label: 'Indoor Advantage Gold CMF impact areas', key: ExportProjectKeys.IndoorAdvantageGoldCmfImpactAreas },
];

export const FavoriteCSVHeader = [
    { label: 'MasterFormat', key: ExportProjectKeys.MasterFormat },
    { label: 'Company', key: ExportProjectKeys.Company },
    { label: 'Transparency Catalog URL', key: ExportProjectKeys.TransparencyCatalogUrl },
    { label: 'Product', key: ExportProjectKeys.ProductName },
    { label: 'Tags', key: ExportProjectKeys.Tags },
    { label: 'Product URL', key: ExportProjectKeys.ProductUrl },
    { label: 'EPD program', key: ExportProjectKeys.EpdProgram },
    { label: 'EPD ID', key: ExportProjectKeys.EpdId },
    { label: 'EPD type', key: ExportProjectKeys.EpdType },
    { label: 'Scope | Region', key: ExportProjectKeys.ScopeRegion },
    { label: 'EC3 embodied carbon', key: ExportProjectKeys.Ec3EmbodiedCarbon },
    { label: 'EC3 Category Status', key: ExportProjectKeys.EC3CategoryStatus },
    { label: 'EPD expires', key: ExportProjectKeys.EpdExpiresDate },
    { label: 'EPD CMF impact areas', key: ExportProjectKeys.EpdCmfImpactAreas },
    { label: 'Health Product Declaration (HPD)', key: ExportProjectKeys.HPD },
    { label: 'HPD Scope | Results', key: ExportProjectKeys.HpdScopeResults },
    { label: 'HPD expires', key: ExportProjectKeys.HpdExpiresDate },
    { label: 'HPD verified', key: ExportProjectKeys.hpdVerified },
    { label: 'HPD CMF impact areas', key: ExportProjectKeys.HpdCmfImpactAreas },
    { label: 'C2C restricted list free', key: ExportProjectKeys.c2cRestrictedListFree },
    { label: 'Living Building Challenge red list free', key: ExportProjectKeys.livingBuildingChallengeRedListFree },
    { label: 'Perkins&Will precautionary list free', key: ExportProjectKeys.perkinsWillPrecautionaryListFree },
    { label: 'Declare', key: ExportProjectKeys.Declare },
    { label: 'Declare results', key: ExportProjectKeys.DeclareResults },
    { label: 'Declare expires', key: ExportProjectKeys.DeclareExpiresDate },
    { label: 'Declare verified', key: ExportProjectKeys.DeclareVerified },
    { label: 'Declare CMF impact areas', key: ExportProjectKeys.DeclareCmfImpactAreas },
    { label: 'C2C certified', key: ExportProjectKeys.C2cCertified },
    { label: 'C2C results', key: ExportProjectKeys.C2cMHCResults },
    { label: 'C2C expires', key: ExportProjectKeys.C2cExpiresDate },
    { label: 'C2C CMF impact areas', key: ExportProjectKeys.C2cCmfImpactAreas },
    { label: 'C2C Material Health Certificate (MHC)', key: ExportProjectKeys.C2cMHC },
    { label: 'C2C MHC results', key: ExportProjectKeys.C2cMHCResults },
    { label: 'C2C MHC expires', key: ExportProjectKeys.C2cMHCExpiresDate },
    { label: 'C2C MHC CMF impact areas', key: ExportProjectKeys.C2cMHCCmfImpactAreas },
    { label: 'Level', key: ExportProjectKeys.Level },
    { label: 'Living Product Challenge (LPC)', key: ExportProjectKeys.LPC },
    { label: 'LPC results', key: ExportProjectKeys.LpcResults },
    { label: 'LPC expires', key: ExportProjectKeys.LpcExpiresDate },
    { label: 'LPC CMF impact areas', key: ExportProjectKeys.LpcCmfImpactAreas },
    { label: 'Manufacturer Inventory (Mfr Inv)', key: ExportProjectKeys.MfrInv },
    { label: 'Mfr Inv | Scope', key: ExportProjectKeys.MfrInvResults },
    // Low-emitting types CSV headers
    { label: 'Intertek Clean Air SILVER Verified', key: ExportProjectKeys.CleanAirSilverVerified },
    { label: 'Intertek Clean Air SILVER Expires', key: ExportProjectKeys.CleanAirSilverExpires },
    { label: 'Clean Air SILVER CMF impact areas', key: ExportProjectKeys.CleanAirSilverCmfImpactAreas },
    { label: 'Intertek Clean Air GOLD Verified', key: ExportProjectKeys.CleanAirGoldVerified },
    { label: 'Intertek Clean Air GOLD Expires', key: ExportProjectKeys.CleanAirGoldExpires },
    { label: 'Clean Air GOLD CMF impact areas', key: ExportProjectKeys.CleanAirGoldCmfImpactAreas },
    { label: 'Berkeley Analytical ClearChem Verified', key: ExportProjectKeys.ClearchemVerified },
    { label: 'Berkeley Analytical ClearChem Expires', key: ExportProjectKeys.ClearchemExpires },
    { label: 'ClearChem CMF impact areas', key: ExportProjectKeys.ClearchemCmfImpactAreas },
    { label: 'SCS Global FloorScore Verified', key: ExportProjectKeys.FloorscoreVerified },
    { label: 'SCS Global FloorScore Expires', key: ExportProjectKeys.FloorscoreExpires },
    { label: 'FloorScore CMF impact areas', key: ExportProjectKeys.FloorscoreCmfImpactAreas },
    { label: 'MAS Green Certified Verified', key: ExportProjectKeys.GreenCertifiedVerified },
    { label: 'MAS Green Certified Expires', key: ExportProjectKeys.GreenCertifiedExpires },
    { label: 'Green Certified CMF impact areas', key: ExportProjectKeys.GreenCertifiedCmfImpactAreas },
    { label: 'UL Solutions GREENGUARD Verified', key: ExportProjectKeys.GreenguardVerified },
    { label: 'UL Solutions GREENGUARD Expires', key: ExportProjectKeys.GreenguardExpires },
    { label: 'GREENGUARD CMF impact areas', key: ExportProjectKeys.GreenguardCmfImpactAreas },
    { label: 'UL Solutions GREENGUARD Gold Verified', key: ExportProjectKeys.GreenguardGoldVerified },
    { label: 'UL Solutions GREENGUARD Gold Expires', key: ExportProjectKeys.GreenguardGoldExpires },
    { label: 'GREENGUARD Gold CMF impact areas', key: ExportProjectKeys.GreenguardGoldCmfImpactAreas },
    { label: 'SCS Global Indoor Advantage Verified', key: ExportProjectKeys.IndoorAdvantageVerified },
    { label: 'SCS Global Indoor Advantage Expires', key: ExportProjectKeys.IndoorAdvantageExpires },
    { label: 'Indoor Advantage CMF impact areas', key: ExportProjectKeys.IndoorAdvantageCmfImpactAreas },
    { label: 'SCS Global Indoor Advantage Gold Verified', key: ExportProjectKeys.IndoorAdvantageGoldVerified },
    { label: 'SCS Global Indoor Advantage Gold Expires', key: ExportProjectKeys.IndoorAdvantageGoldExpires },
    { label: 'Indoor Advantage Gold CMF impact areas', key: ExportProjectKeys.IndoorAdvantageGoldCmfImpactAreas },
];
